import {
  BackgroundIcon,
  getTranslatedText,
  TABLE_ROWCOUNT_OPTIONS
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Dropdown } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

const PaginationWrapper = styled.div`
  display: flex;
  height: 46px;
  background: ${(props) =>
    props.backgroundTransparent ? 'transparent' : 'var(--sops-table-bg)'};
  margin: ${(props) => (props.cardTable ? '0px 40px' : '0px')};

  .Table__visiblePagesWrapper,
  .Table__prevPageWrapper,
  .Table__nextPageWrapper,
  .Table__pagination {
    display: flex;
  }
  .Table__pageButton,
  .Table__navButton {
    border: none;
    cursor: pointer;
    background: ${(props) =>
      props.backgroundTransparent ? 'transparent' : 'var(--sops-table-bg)'};
    min-width: 34px;
    min-height: 34px;
    margin: 6px 0;
    border-radius: 4px;
  }
  .Table__navButton {
    margin: ${(props) => (props.cardTable ? '6px 6px' : '6px 12px')};
    border: 1px solid #dbdfe3;
  }
  .Table__pageButton--disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  .Table__pageButton--active {
    border: 1px solid #4a4a4a;
    background-color: #fff;
  }
  .row-options-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .row-options {
    width: 60px;
  }
`;

const Count = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.8);
`;

const defaultButton = (props) => <button {...props}>{props.children}</button>;

class Pagination extends React.Component {
  constructor(props) {
    super();

    this.changePage = this.changePage.bind(this);

    this.state = {
      visiblePages: this.getVisiblePages(props.page, props.pages)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.pages !== nextProps.pages ||
      this.props.page !== nextProps.page
    ) {
      this.setState({
        visiblePages: this.getVisiblePages(nextProps.page, nextProps.pages)
      });
    }

    //this.changePage(nextProps.page + 1);
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter((page) => page <= totalPages);
  };

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total);
    }
    if (page % 5 >= 0 && page > 4 && page + 1 < total) {
      return [1, page - 1, page, page + 1, total];
    }
    if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
      return [1, total - 3, total - 2, total - 1, total];
    }
    return [1, 2, 3, 4, 5, total];
  };

  changePage(page) {
    const activePage = this.props.page;

    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);
    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages)
    });

    this.props.onPageChange(page);
  }

  getStartCount = () => {
    const activePage = this.props.page;
    const { rowCount, recordCount } = this.props;
    return (activePage - 1) * rowCount + 1;
  };

  getEndCount = () => {
    const activePage = this.props.page;
    const { rowCount, recordCount } = this.props;
    const endCount = activePage * rowCount;
    return endCount <= recordCount ? endCount : recordCount;
  };

  render() {
    const PageButtonComponent = defaultButton;
    const { visiblePages } = this.state;
    const activePage = this.props.page;
    const { rowCount, recordCount, cardTable, intl, setRowCount } = this.props;
    const showing = getTranslatedText(
      intl,
      'admin.serviceCatalog.pagination.showing'
    );
    const of = getTranslatedText(intl, 'admin.serviceCatalog.pagination.of');
    const perPage = getTranslatedText(intl, 'table.pagination.perPage');

    if (this.props.renderPagination) {
      return React.cloneElement(this.props.renderPagination, {
        previousPage: () => {
          if (activePage === 1) return;
          this.changePage(activePage - 1);
        },
        isPreviousDisabled: activePage === 1,
        nextPage: () => {
          if (activePage === this.props.pages) return;
          this.changePage(activePage + 1);
        },
        isNextDisabled: activePage === this.props.pages,
        totalCount: recordCount,
        activePage,
        totalPages: this.props.pages,
        startCount: this.getStartCount(),
        endCount: this.getEndCount()
      });
    }
    return (
      <>
        <PaginationWrapper
          cardTable={cardTable}
          backgroundTransparent={this.props.backgroundTransparent}
          setRowCount={setRowCount}
        >
          <div className="Table__pagination">
            {this.props.dynamicRowCount && !!recordCount && !!rowCount && (
              <Count className="ml8">{`${showing} ${this.getStartCount()}-${this.getEndCount()} ${of} ${recordCount}`}</Count>
            )}
            <div className="Table__prevPageWrapper">
              {!!recordCount && !!rowCount && (
                <PageButtonComponent
                  className={
                    activePage === 1
                      ? 'Table__navButton Table__pageButton--disabled'
                      : 'Table__navButton'
                  }
                  onClick={() => {
                    if (activePage === 1) return;
                    this.changePage(activePage - 1);
                  }}
                  disabled={activePage === 1}
                >
                  {this.props.previousText || <SVGIcon name="ArrowLeft" />}
                </PageButtonComponent>
              )}
            </div>
            <div className="Table__visiblePagesWrapper">
              {visiblePages.map((page, index, array) => {
                return (
                  <>
                    {array[index - 1] + 1 < page ? (
                      <div className="ml8 mr8 flex center">...</div>
                    ) : (
                      ''
                    )}
                    <PageButtonComponent
                      key={page}
                      className={
                        activePage === page
                          ? 'Table__pageButton Table__pageButton--active'
                          : 'Table__pageButton'
                      }
                      onClick={this.changePage.bind(null, page)}
                    >
                      {page}
                    </PageButtonComponent>
                  </>
                );
              })}
            </div>
            <div className="Table__nextPageWrapper">
              {!!recordCount && !!rowCount && (
                <PageButtonComponent
                  className={
                    activePage === this.props.pages
                      ? 'Table__navButton Table__pageButton--disabled'
                      : 'Table__navButton'
                  }
                  onClick={() => {
                    if (activePage === this.props.pages) return;
                    this.changePage(activePage + 1);
                  }}
                  disabled={activePage === this.props.pages}
                >
                  {this.props.nextText || <SVGIcon name="ArrowRight" />}
                </PageButtonComponent>
              )}
            </div>
            {!this.props.dynamicRowCount && recordCount && rowCount && (
              <Count>{`${showing} ${this.getStartCount()}-${this.getEndCount()} ${of} ${recordCount}`}</Count>
            )}
          </div>

          {this.props.dynamicRowCount && !!recordCount && !!rowCount && (
            <div className="row-options-wrapper">
              <div className="row-options">
                <Dropdown
                  options={TABLE_ROWCOUNT_OPTIONS}
                  value={TABLE_ROWCOUNT_OPTIONS.find(
                    (el) => el.value === this.props.rowCount
                  )}
                  menuPortalTarget={document.body}
                  menuPlacement="top"
                  menuShouldScrollIntoView={false}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 })
                  }}
                  onChange={(val) => setRowCount(val.value)}
                />
              </div>
              <p>{perPage}</p>
            </div>
          )}
        </PaginationWrapper>
      </>
    );
  }
}

export default injectIntl(Pagination);
